import { useQuery } from '@tanstack/react-query';

import type { JiraTransition, JiraTransitionsResponse } from '@/types';

import { useAxios } from './useAxios';

export interface UseJiraTransitionsOptions {
  accountKey?: string;
  projectKey?: string;
  config?: Record<string, unknown>;
  enabled?: boolean;
}

export interface UseJiraTransitionsResult {
  statuses: JiraTransition[];
  suggestedOpenToClose: JiraTransition[];
  suggestedCloseToOpen: JiraTransition[];
}

export const useJiraTransitions = ({
  accountKey,
  projectKey,
  config,
  enabled = true,
}: UseJiraTransitionsOptions) => {
  const axios = useAxios();

  return useQuery({
    queryKey: ['jira', 'transitions', projectKey, accountKey ?? 'new'],
    queryFn: async (): Promise<UseJiraTransitionsResult> => {
      const response = await axios.post<JiraTransitionsResponse>(
        '/integration/jira/transitions',
        {
          provider: 'jira',
          account: accountKey,
          secret: accountKey ? undefined : config,
          settings: { getTransitions: true, projectKey },
          projectKey,
        }
      );

      const data = response.data;

      return {
        statuses: data?.statuses || [],
        suggestedOpenToClose: data?.suggestedOpenToClose || [],
        suggestedCloseToOpen: data?.suggestedCloseToOpen || [],
      };
    },
    enabled: enabled && !!projectKey && (!!accountKey || !!config),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
